var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypalButton"},[(!_vm.resetPaypal && _vm.allowSubmit)?_c('div',[_c('div',{ref:"paypalBtn"})]):_c('button',{staticClass:"pill",on:{"click":function($event){return _vm.emitClick($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }